import moment from 'moment';
import 'moment/locale/fr'; // Import French locale

// Set default locale to French
moment.locale('fr');

/** Format a Date as JJ/MM/AAAA for typed date inputs. */
export const formatDateInput = (date) => {
  if (!date) return '';
  const momentDate = moment(date);
  if (!momentDate.isValid()) return '';
  return momentDate.format('DD/MM/YYYY');
};

/** Mask raw input into DD/MM/YYYY while typing. */
export const maskDateInput = (raw) => {
  const digits = String(raw || '')
    .replace(/\D/g, '')
    .slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

/**
 * Parse a JJ/MM/AAAA string into a Date at local midnight.
 * @returns {Date|null}
 */
export const parseDateInput = (text) => {
  const match = String(text || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return null;
  const parsed = moment(`${match[1]}/${match[2]}/${match[3]}`, 'DD/MM/YYYY', true);
  if (!parsed.isValid()) return null;
  return parsed.toDate();
};

export const formatDate = (date, options = {}) => {
  if (!date) return '';

  const { format = 'medium', includeTime = false, locale = 'fr' } = options;

  try {
    // Create moment object - automatically converts to local timezone
    const momentDate = moment(date);

    // Check if date is valid
    if (!momentDate.isValid()) {
      return '';
    }

    // Set locale for this specific date
    momentDate.locale(locale);

    // Handle predefined formats
    let formatString;

    switch (format) {
      case 'short':
        formatString = includeTime ? 'DD/MM/YYYY, HH:mm' : 'DD/MM/YYYY';
        break;

      case 'medium':
        formatString = includeTime ? 'DD MMM YYYY, HH:mm' : 'DD MMM YYYY';
        break;

      case 'long':
        formatString = includeTime ? 'DD MMMM YYYY, HH:mm' : 'DD MMMM YYYY';
        break;

      case 'full':
        formatString = includeTime ? 'dddd DD MMMM YYYY, HH:mm' : 'dddd DD MMMM YYYY';
        break;

      default:
        // If format is not a predefined type, assume it's a custom moment format string
        formatString = format;
        break;
    }

    return momentDate.format(formatString);
  } catch {
    return '';
  }
};
